import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import axios from "axios";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import {defaultComponents} from "../../../controls/Material-Table-Components";
import { TablePagination, IconButton, Button, useTheme} from "@material-ui/core";
import SystemContext from "../../../SystemContext";
import { ColumnWidth } from "../../../blocks/ColumnHelper";
import { ReactComponent as PdfLogo } from "../../../assets/pdf.svg"; 
import { ReactComponent as ExcelLogo } from "../../../assets/excel.svg";
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CachedIcon from '@material-ui/icons/Cached';
import { useViewFuelAnnexesOutstanding } from "../../../services/fuel";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
import FuelAnnexView from "./FuelAnnexView";
import AdhocAnnexDialog from "./AdhocAnnexDialog";

const apiSitePrefix = getApiSitePrefix();

const FuelAnnexesOutstandingList = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const props = {
    ..._props
  }
  const classes = _props.classes;

  const [state, setState] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});
  const queryClient = useQueryClient();
  const extraKeys = [];


  const downloadPdf = (rowData) => {
    window.open(rowData.generatedPdf, "_blank");
  }

  const downloadExcel = (rowData) => {
    window.open(rowData.generatedExcel, "_blank");
  }

  const generateAnnex = async (rowData) => {
    SystemData.toggleLoadingProgress(true);
    await axios.post(`${apiSitePrefix}/fuelannexes/build/${rowData.fuelAnnexUuid}/${rowData.effectiveDate}`);
    queryClient.invalidateQueries(["FuelAnnexesOutstanding"]);
    SystemData.toggleLoadingProgress(false);
  }

  const completeAnnex = async (rowData) => {
    await axios.put(`${apiSitePrefix}/fuelannex/complete/${rowData.fuelAnnexHistoryUuid}`);
    queryClient.invalidateQueries(["FuelAnnexesOutstanding"]);
  }

  const FuelAnnexesOutstanding = useViewFuelAnnexesOutstanding({tableRef, queryClient, extraKeys});

  const {show : showAdhocDialogBox, dialogBox : adhocDialogBox } = AdhocAnnexDialog(SystemData, apiSitePrefix, queryClient);

  const getColumns = (props) => { 
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };

    return [
      {
        ...baseColumn,
        cellStyle: { padding: "8px 10px", minWidth: 300},
        headerStyle: { padding: "8px 10px", minWidth: 300},
        title: "Company Name",
        field: "companyName",
        initialEditValue: "",
      },
      {
        ...baseColumn,
        ...ColumnWidth(150),
        title: "Company Code",
        field: "companyCode",
        initialEditValue: "",
      },
      {
        ...baseColumn,
        ...ColumnWidth(300),
        title: "Contract No",
        field: "contractNo",
        initialEditValue: "",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120),
        title: "Valid From",
        field: "validFrom",
        type: "date",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120),
        title: "Valid To",
        field: "validTo",
        type: "date",
      },
      {
        ...baseColumn,
        ...ColumnWidth(120),
        title: "Effective Date",
        field: "effectiveDate",
        type: "date",
      },
      {
        ...baseColumn,
        title: "",
      }
    ];
  };
  
  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <MaterialTable
            tableRef={tableRef}
            style={{
              border: "none",
              boxShadow: "none",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.tableHeader.backgroundColor,
                color: theme.palette.tableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              pageSize: 10,
              detailPanelType: "single",
            }}
            components={{
              ...defaultComponents,
              Pagination: (props) => (
                  <TablePagination
                      {...props}
                      rowsPerPageOptions={[5, 10, 15]}
                  />
              ),
              Action: _props => {
                let props = {..._props};
                if (typeof props.action.action === "function") {
                  props.action = {..._props.action, ..._props.action.action(_props.data)};
                }

                if (props.action.icon==="pdf") {
                  return (
                    <IconButton
                      disabled={props.data.generatedPdf?false:true}
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      <PdfLogo width={24} height={24} style={{width: 24, height:24, fill: props.data.generatedPdf?'#ff0000':'#d0d0d0' }}/>
                    </IconButton>
                  )
                } else if (props.action.icon === "excel") {
                  return (
                    <IconButton
                      disabled={props.data.generatedExcel?false:true}
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      <ExcelLogo width={24} height={24} style={{width: 24, height:24, fill: props.data.generatedExcel?'#1d6f42':'#d0d0d0'}}/>
                    </IconButton>
                  )  
                } else if (props.action.icon === "regenerate") {                  
                  return (
                    <IconButton
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      <CachedIcon width={24} height={24} style={{width: 24, height:24, ...props.style}}/>
                    </IconButton>
                  )  
                } else if (props.action.icon==="generate") {
                  return (
                    <Button style={{height:24, marginTop:12}}
                      variant="contained"
                      color="primary"
                      startIcon={<PlayIcon />}
                      className={classes.button}
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      {props.action.text}
                    </Button>
                  )  
                } else if (props.action.icon==="complete") {
                  return (
                    <Button style={{height:24, marginTop:12}}
                      variant="contained"
                      color="secondary"
                      startIcon={<CheckIcon />}
                      className={classes.button}
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      {props.action.text}
                    </Button>
                  )  
                } else if (props.action && !props.action.hidden) {
                  return (
                    <Button style={{height:24, marginTop:12}}
                      variant="contained"
                      className={classes.button}
                      onClick={()=>{props.action.onClick(props.data)}}
                    >
                      {props.action.text}
                    </Button>
                  )  
                } else {
                  return (<></>)
                }
              }
            }}
            title="Outstanding Fuel Annexes"
            columns={getColumns({classes: classes, canEdit: state.canEdit})}
            detailPanel={[
              rowData => ({
                disabled: !rowData.annexData || !rowData.fuelAnnexHistoryUuid,
                tooltip: "Show Annex Details",
                render: (rowData) => {
                  return (
                    <div>
                      <FuelAnnexView
                        annexData={rowData.annexData}
                        effectiveDate={rowData.effectiveDate}
                      />
                    </div>
                  );
                },
              })
            ]}
            data={FuelAnnexesOutstanding.data}
            actions={
              [
                {
                  icon: "pdf",
                  tooltip: "Download PDF",
                  onClick: downloadPdf
                },
                {
                  icon: "excel",
                  tooltip: "Download Excel",
                  onClick: downloadExcel
                },
                (rowData) => {
                  return rowData.generatedExcel && rowData.generatedPdf && rowData.fuelAnnexHistoryUuid ? {
                    icon: "regenerate",
                    text: "Regenerate",
                    tooltip: "Regenerate Excel and PDF Fuel Annexes",
                    onClick: generateAnnex
                  } : {
                    hidden: true
                  } 
                },
                (rowData) => {
                  return rowData.generatedExcel && rowData.generatedPdf && rowData.fuelAnnexHistoryUuid ? {
                    icon: "complete",
                    text: "Complete",
                    tooltip: "When the annexes have been generated and sent, click to mark as completed",
                    onClick: completeAnnex
                  } : {
                    icon: "generate",
                    text: "Generate",
                    tooltip: "Generate Excel and PDF Fuel Annexes",
                    onClick: generateAnnex
                  }
                },
                {
                  hidden: false,
                  icon: 'generate',
                  text: "Add",
                  tooltip: 'Generate Adhoc Annex',
                  isFreeAction: true,
                  onClick: () => { showAdhocDialogBox(); }
                },
              ]
            }
        />
        {adhocDialogBox}
      </div>
  );

}

export default FuelAnnexesOutstandingList;
